import { Checkbox } from '@mantine/core';
import classes from './Checkbox.module.scss';

interface CustomisedCheckboxProps {
  name: string;
  title: string;
  colourTheme: string;
  isChecked: boolean;
  onCheckboxChange?: (name: string, isChecked: boolean) => void;
}

export default function CustomisedCheckbox({ name, title, colourTheme, isChecked, onCheckboxChange }: CustomisedCheckboxProps) {

  const handleCheckboxChange = () => {
    if(onCheckboxChange) {
      onCheckboxChange(name, !isChecked);
    }
  };

  return (
    <Checkbox
      size="xxl"
      classNames={classes}
      style={{backgroundColor: `${colourTheme}90`, borderColor: colourTheme}}
      color={colourTheme}
      label={title}
      checked={isChecked}
      onChange={handleCheckboxChange}
      wrapperProps={{
        onClick: () => handleCheckboxChange(),
      }}
    />
  );
}
